import Vue from 'vue'
import Router from 'vue-router'
import store from './store.js'
import Index from './views/Index.vue'
import Service from './views/Service.vue'
import ServiceDetails from './views/Service_details.vue'
import orders_tk from './views/orders_tk/orders_tk.vue'
import orders_tk_details from './views/orders_tk/details.vue'
import Account from './views/Account.vue'
import Connection from './views/Connection.vue'
import Login from './views/Login.vue'
import Orders from './views/orders'
import orders_ from './views/orders_'
import orders_foster from './views/orders_foster'
import orders_foster_records from './views/orders_foster_records'
import OrdersDetail from './views/orders/detail'
import NurseManagement from './views/nurse-management/index'
import Hospital from './views/hospital/index'
import DiscountManagement from './views/discount/index'
import DiscountDetail from './views/discount/detail'
import Financial from './views/financial/index'
import NotFound from './views/NotFound.vue'
import Statistics from './views/statistics'
import { isAdmin } from './utils/util'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV === 'development' ? '/' : '/manage',
  routes: [
    {
      path: '/login',
      component: Login
    },
    {
      path: '/',
      component: Index,
      children: [
        {
          path: '/service',
          name: 'service',
          component: Service
        },
        {
          path: '/details',
          name: 'details',
          component: ServiceDetails
        },
        {
          path: '/account',
          name: 'account',
          component: Account
        },
        {
          path: '/connection',
          name: 'connection',
          component: Connection
        },
        {
          path: '/orders',
          name: 'orders',
          component: Orders
        },
        {
          path: '/orders_',
          name: 'orders_',
          component: orders_
        },
        {
          path: '/orders_tk',
          name: 'orders_tk',
          component: orders_tk
        },
        {
          path: '/orders_tk_details',
          name: 'orders_tk_details',
          component: orders_tk_details
        },
        {
          path: '/orders_foster',
          name: 'orders_foster',
          component: orders_foster
        },
        {
          path: '/orders_foster_records',
          name: 'orders_foster_records',
          component: orders_foster_records
        },
        {
          path: '/order-details',
          name: 'ordersDetail',
          component: OrdersDetail
        },
        {
          path: '/financial',
          name: 'financial',
          component: Financial
        },
        {
          path: '/statistics',
          name: 'Statistics',
          component: Statistics
        },
        {
          path: '/nurse-management',
          name: 'NurseManagement',
          component: NurseManagement
        },
        {
          path: '/hospital-management',
          name: 'Hospital',
          component: Hospital
        },
        {
          path: '/discount-management',
          name: 'DiscountManagement',
          component: DiscountManagement
        },
        {
          path: '/discount-detail/:id',
          name: 'DiscountDetail',
          component: DiscountDetail
        },
        {
          path: '/404',
          component: NotFound
        }
      ]
    },
    {
      path: '*',
      redirect: { path: '/404' }
    }
  ]
})

// 全局路由守卫
router.beforeEach(async (to, from, next) => {
  const LOGINURL = '/login'

  const url = to.path
  const token = sessionStorage.getItem('AuthToken')
  const roles = store.state.rules

  if (url === LOGINURL) {
    sessionStorage.removeItem('AuthToken')
  }

  // 判断是否登录
  if (!token && url !== LOGINURL) {
    next({ path: LOGINURL })
  } else {
    if (!(roles && roles !== '' && roles.length)) {
      store.commit('INIT_ROLES', JSON.parse(sessionStorage.getItem('role')))
    }
    if (url === '/account' && !isAdmin()) {
      next({ path: '/' })
    } else {
      next()
    }
  }
})

export default router
